import React from "react";
import { useQuery } from "@tanstack/react-query";
import { FileDown, FileSpreadsheet, FileText } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";
import { exportCommercialista } from "../lib/exporter";

export function ExportCommercialista({ month, structureId, subtitle, meseLabel, color, testid = "export-commercialista" }) {
  const { structures = [], companyLogo } = useAuth();
  const structMap = {};
  structures.forEach((s) => { structMap[s.id] = s.nome; });
  const grouped = structureId === "all";
  const { data: pagamenti = [] } = useQuery({
    queryKey: ["comm-pag", structureId],
    queryFn: async () => (await api.get("/pagamenti", { params: { structure_id: structureId } })).data,
  });
  const { data: ospiti = [] } = useQuery({
    queryKey: ["comm-osp", structureId],
    queryFn: async () => (await api.get("/ospiti", { params: { structure_id: structureId } })).data,
  });
  const run = (format) => {
    const byId = {};
    ospiti.forEach((o) => { byId[o.id] = o; });
    const righe = pagamenti
      .filter((p) => p.mese === month)
      .map((p) => {
        const o = byId[p.ospite_id] || {};
        const parts = (p.ospite_nome || "").trim().split(/\s+/);
        return {
          cognome: o.cognome || parts.slice(-1)[0] || "",
          nome: o.nome || parts.slice(0, -1).join(" ") || p.ospite_nome || "",
          pagato: Number(p.importo_incassato || 0),
          struttura: structMap[p.structure_id] || "—",
        };
      })
      .sort((a, b) => (grouped ? String(a.struttura).localeCompare(String(b.struttura), "it") : 0) || String(a.cognome).localeCompare(String(b.cognome), "it", { sensitivity: "base" }));
    if (!righe.length) { toast.error("Nessuna retta per questo mese"); return; }
    try {
      exportCommercialista({ format, subtitle, meseLabel: meseLabel || month, righe, grouped, color, logo: companyLogo });
      toast.success(`Report ${format === "excel" ? "Excel" : "PDF"} generato`);
    } catch (e) { toast.error("Errore durante l'esportazione"); }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" data-testid={`${testid}-btn`}><FileDown size={16} className="mr-1" /> Report commercialista</Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => run("excel")} data-testid={`${testid}-excel`}><FileSpreadsheet size={15} className="mr-2 text-emerald-600" /> Excel (.xlsx)</DropdownMenuItem>
        <DropdownMenuItem onClick={() => run("pdf")} data-testid={`${testid}-pdf`}><FileText size={15} className="mr-2 text-red-600" /> PDF</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
